<div>
  <div class="d-flex flex-row" style="align-items: center">
    <bdg-label type="subheading-1">{{ label }}</bdg-label>
    <mat-label error="true"></mat-label>
    <mat-icon
      *ngIf="control.invalid && (control.dirty || control.touched)"
      matSuffix
      class="mat-icon notranslate mat-error material-icons radio-error-icon"
      style="margin-left: 0.25rem"
      >error</mat-icon
    >
  </div>

  <div class="mt-1 pb-1">
    <mat-radio-group [formControl]="control" id="radio-1" #nativeElement>
      <div [class]="displayClass">
        <mat-radio-button
          *ngFor="let option of provider.options"
          [value]="option.value"
          [class]="radioClass"
          [checked]="isChecked(option)"
          [disabled]="option.disabled"
        >
          {{ option.descricao }}
        </mat-radio-button>
      </div>
    </mat-radio-group>
  </div>

  <div class="radio-field-subscript-wrapper" *ngIf="control.invalid && (control.dirty || control.touched)">
    <div class="radioSubscriptionWrapper">
      <div class="ml-1">
        <mat-hint>{{ hint }}</mat-hint>
        <mat-error class="mat-caption" *ngIf="errorMessage">{{ errorMessage }}</mat-error>
      </div>
    </div>
  </div>
</div>
